import { AccountDetail } from '@repo/accounts-types'
import { ApiResponse, Service } from '@repo/core'
import { AxiosRequestConfig } from 'axios'

export interface AccountDetailQueryParams {
  accountId: string
  currency?: string
  date?: string
  interventionType?: string
}

export const getAccountDetail: Service<
  AccountDetailQueryParams,
  ApiResponse<AccountDetail>,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, accept, config }) => {
  const { accountId, ...queryParams } = params

  return api.get<ApiResponse<AccountDetail>>(`/accounts/securities/${accountId}`, {
    params: queryParams,
    ...config,
    ...(accept && { headers: { Accept: accept }, responseType: 'blob' as const }),
  })
}
